import React, { useState } from "react";
import "./App.css";
import SearchForm from "./components/SearchForm";
import Results from "./components/Results";
import Photo from "./components/Photo";
import Dashboard from "./components/Dashboard";

export default function App() {
  let [keyword, setKeyword] = useState("");

  function handleSearch(searchedKeyword) {
    setKeyword(searchedKeyword);
  }

  return (
    <div className="App">
      <Dashboard />

      <div className="SearchCard">
        <h1 className="SearchCard-title">Quale parola vuoi cercare?</h1>
        <SearchForm onSearch={handleSearch} />
        <p className="SearchCard-hint">es. gatto, viaggio, colore, programmazione</p>
      </div>

      {keyword && <Photo keyword={keyword} key={`photo-${keyword}`} />}
      {keyword && <Results keyword={keyword} key={keyword} />}

      <footer className="App-footer">
        This project was coded by{" "}
        <a
          href="https://github.com/TUMMENE"
          target="_blank"
          rel="noopener noreferrer"
        >
          Tumi Menegalli
        </a>{" "}
        and is open-sourced on{" "}
        <a
          href="https://github.com/TUMMENE/dictionary-panoramica"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>{" "}
        and hosted on{" "}
        <a
          href="https://www.netlify.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Netlify
        </a>
        .
      </footer>
    </div>
  );
}
